import inventory from '@/api/report/inventory'
import { baseState, baseMutations } from '@/store/mixins'
import { camelCase, mapKeys } from 'lodash'
import moment from 'moment'

class QCByPagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  QcPagination: new QCByPagination(),
  QcResources: [],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  RECEIVE_RESOURCES_QC(state, { data, ...meta }) {
    state.QcResources = []
    data.forEach(resource => {
      state.QcResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.QcPagination = new QCByPagination(mapKeys(meta.meta, (v, k) => camelCase(k)))
  }

}

export const actions = {
  // generate daily sale item pdf
  dailySaleItem(context, attributes = {}) {
    return inventory.dailySaleItem({ params: attributes })
  },
  // generate daily sale item excel
  dailySaleItemExcel(context, payload) {
    return inventory.dailySaleItemExcel(payload)
  },
  // generate sale item details
  saleItemDetail(context, attributes = {}) {
    return inventory.saleItemDetail({ params: attributes })
  },
  // generate stock in detail as pdf
  stockInDetail(context, data) {
    return inventory.stockInDetail(data)
  },
  // export stock in detail as excel
  stockInDetailExcel(context, payload) {
    return inventory.stockInDetailExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate stock in summary
  stockInSummary(context, attributes = {}) {
    return inventory.stockInSummary({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // export stock in summary
  stockInSummaryExcel(context, payload = {}) {
    return inventory.stockInSummaryExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate detail inventory list
  detailInventoryList(context, attributes = {}) {
    return inventory.detailInventoryList({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate summary inventory list
  summaryInventoryList(context, attributes = {}) {
    return inventory.summaryInventoryList({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // export summary inventory list excel
  summaryInventoryListExcel(context, payload = {}) {
    return inventory.summaryInventoryListExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate product item
  productItemList(context, attributes = {}) {
    return inventory.productItemList({ params: attributes })
  },
  // generate purchase order list
  purchaseOrderList(context, attributes = {}) {
    return inventory.purchaseOrderList({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate purchase order list
  purchaseOrderSummary(context, data) {
    return inventory.purchaseOrderSummary(data)
  },
  purchaseOrderSummaryExcel(context, data) {
    return inventory.purchaseOrderSummaryExcel(data)
  },
  // generate monthly sale item
  monthlySaleItem(context, data) {
    return inventory.monthlySaleItem(data)
  },
  // generate monthly sale item as excel
  monthlySaleItemExcel(context, payload) {
    return inventory.monthlySaleItemExcel(payload)
  },
  // generate stock transfer
  stockTransfer(context, attributes = {}) {
    return inventory.stockTransfer({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate stock transfer as excel
  stockTransferExcel(context, payload) {
    return inventory.stockTransferExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate yearly sale items
  yearlySaleItem(context, attributes = {}) {
    return inventory.yearlySaleItem({ params: attributes })
  },
  yearlySaleItemExcel(context, data) {
    return inventory.yearlySaleItemExcel(data)
  },
  productList(context) {
    return inventory.productList()
  },
  productListExcel(context) {
    return inventory.productListExcel()
  },
  productSerial(context, data) {
    return inventory.productSerial(data)
  },
  productSerialExcel(context, data) {
    return inventory.productSerialExcel(data)
  },
  detailInventoryListToExcel(context, data) {
    return inventory.detailInventoryListToExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  sparePartReplacement(context, data) {
    return inventory.sparePartReplacement(data)
  },
  sparePartReplacementExcel(context, data) {
    return inventory.sparePartReplacementExcel(data)
  },
  productItemListExcel(context, payload) {
    return inventory.productItemListExcel(payload)
  },
  qcByExcel(context, payload) {
    return inventory.qcByExcel(payload)
  },
  async qcBy(context, attributes = {}) {
    let response = await inventory.qcBy({
      params: Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage
        },
        attributes
      )
    })
    context.commit('RECEIVE_RESOURCES_QC', response)
    return response;
  },
  getLocation(context, { branch_id }) {
    return inventory.getLocation({ branch_id })
  },
  // generate inventory min max
  inventoryMinMax(context, attributes = {}) {
    return inventory.inventoryMinMax({ params: attributes })
  },
  inventoryMinMaxExcel(context, data) {
    return inventory.inventoryMinMaxExcel(data)
  },
  productWarrantyExpired(context, attributes = {}) {
    return inventory.productWarrantyExpired({ params: attributes })
  },
  productWarrantyExpiredExcel(context, data) {
    return inventory.productWarrantyExpiredExcel(data)
  },
  stockAdjustment(context, attributes = {}) {
    return inventory.stockAdjustment(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    )
  },
  stockAdjustmentExcel(context, data) {
    return inventory.stockAdjustmentExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  stockReturn(context, attributes = {}) {
    return inventory.stockReturn(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    )
  },
  stockReturnExcel(context, data) {
    return inventory.stockReturnExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  detailTransfer(context, attributes = {}) {
    return inventory.detailTransfer(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    )
  },
  detailTransferExcel(context, data) {
    return inventory.detailTransferExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  transferPendingStatus(context, attributes = {}) {
    return inventory.transferPendingStatus(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    )
  },
  transferPendingStatusExcel(context, data) {
    return inventory.transferPendingStatusExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  // generate inventory min max 2
  inventoryMinMax2(context, attributes = {}) {
    return inventory.inventoryMinMax2({ params: attributes })
  },
  inventoryMinMax2Excel(context, data) {
    return inventory.inventoryMinMax2Excel(data)
  },
  simSerial(context, data) {
    return inventory.simSerial(data)
  },
  simSerialExcel(context, data) {
    return inventory.simSerialExcel(data)
  },
  getBranch(context, attributes = {}) {
    return report.getBranch({ params: attributes })
  },
}
